<template>
  <custom-actions show-back>
    <el-form ref="form" :model="form" :rules="rules" label-width="150px" :disabled="saving">
      <el-row :gutter="24">
        <el-col :span="12"><el-form-item label="作业类型" prop="workType"><el-select v-model="form.workType" @change="changeType"><el-option v-for="(label, value) in workTypes" :key="value" :label="label" :value="value" /></el-select></el-form-item></el-col>
        <el-col v-for="field in baseFields" :key="field[0]" :span="field[0] === 'workContent' ? 24 : 12">
          <el-form-item :label="field[1]" :prop="field[0]"><el-input v-model.trim="form[field[0]]" :type="field[0] === 'workContent' ? 'textarea' : 'text'" :maxlength="field[0] === 'workContent' ? 1000 : field[0] === 'applicantMobile' ? 20 : field[0] === 'applicantName' ? 50 : 100" /></el-form-item>
        </el-col>
        <el-col :span="12"><el-form-item label="计划开始时间" prop="startTime"><el-date-picker v-model="form.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item></el-col>
        <el-col :span="12"><el-form-item label="计划结束时间" prop="endTime"><el-date-picker v-model="form.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item></el-col>
        <el-col v-for="field in activeFields" :key="field[0]" :span="12"><el-form-item :label="field[1]"><el-input v-model.trim="form[field[0]]" :maxlength="['operationLevel', 'guardianName'].includes(field[0]) ? 100 : 200" /></el-form-item></el-col>
      </el-row>
      <el-form-item label="申请材料"><file-upload v-model="form.applicationFiles" :update="false" /></el-form-item>
      <el-form-item label="申请人签字" prop="applicantSignature"><file-upload v-model="form.applicantSignature" :update="false" accept=".png,.jpg,.jpeg" :limit="1" :multiple="false"><template #tip><div>请上传申请人本人手写签名图片。</div></template></file-upload></el-form-item>
      <el-form-item><el-button v-if="canAdd" type="primary" :loading="saving" @click="submit">提交申请</el-button><el-button @click="$router.push('/specialWork/list')">取消</el-button></el-form-item>
    </el-form>
  </custom-actions>
</template>

<script>
import { workTypes, typeFields, baseFields } from './fields'

export default {
  name: 'SpecialWorkAdd',
  data() {
    const form = { workType: '1', startTime: '', endTime: '', applicationFiles: [], applicantSignature: [] }
    const rules = { workType: [{ required: true, message: '请选择作业类型', trigger: 'change' }], applicantSignature: [{ type: 'array', required: true, min: 1, message: '请上传申请人签字', trigger: 'change' }] }
    baseFields.forEach(([key, label]) => { form[key] = ''; rules[key] = [{ required: true, message: '请填写' + label, trigger: 'blur' }] })
    Object.values(typeFields).flat().forEach(([key]) => { form[key] = '' })
    rules.startTime = [{ required: true, message: '请选择计划开始时间', trigger: 'change' }]
    rules.endTime = [{ required: true, message: '请选择计划结束时间', trigger: 'change' }]
    return { form, rules, workTypes, baseFields, saving: false }
  },
  computed: {
    activeFields() { return typeFields[this.form.workType] || [] },
    canAdd() { return this.$store.getters.getMenuByCode('TSZY').includes('add') }
  },
  methods: {
    // 切换类型清空所有专属字段，防止把动火等级等旧值带入另一类作业。
    changeType() { Object.values(typeFields).flat().forEach(([key]) => { this.form[key] = '' }) },
    async submit() {
      if (this.saving || !this.canAdd) return
      const valid = await this.$refs.form.validate().catch(() => false)
      if (!valid) return
      if (this.form.endTime <= this.form.startTime) { this.$message.warning('计划结束时间必须晚于开始时间'); return }
      this.saving = true
      try {
        // 提交白名单字段，避免无关分类字段污染后端宽表。
        const keys = ['workType', 'startTime', 'endTime', 'applicationFiles', 'applicantSignature', ...baseFields.map(field => field[0]), ...this.activeFields.map(field => field[0])]
        const payload = {}
        keys.forEach(key => { payload[key] = this.form[key] })
        await this.$axios.post(this.$apis.specialWork.add, payload)
        this.$router.push('/specialWork/list')
      } catch (error) { /* 接口失败保留表单，便于修正后重新提交。 */ } finally { this.saving = false }
    }
  }
}
</script>
